import { Card, CardContent, cn } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

export type ListEmptyStateProps = {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
  contentClassName?: string;
  /**
   * `default` — quiet empty / no-results.
   * `error` — load-failure panels (destructive icon well).
   */
  tone?: 'default' | 'error';
};

/**
 * Centered empty / no-results / load-error panel for resource list pages.
 * Quiet Status Board empty — Profiles composition typography (`--t-h3` / `--t-body`).
 */
export function ListEmptyState({
  icon,
  title,
  description,
  action,
  className,
  contentClassName,
  tone = 'default',
}: ListEmptyStateProps) {
  return (
    <Card className={className}>
      <CardContent
        className={cn(
          'flex flex-1 flex-col items-center justify-center gap-4 p-8 text-center sm:p-12',
          contentClassName,
        )}
      >
        {icon ? (
          <div
            className={cn(
              'flex h-12 w-12 items-center justify-center rounded-2xl',
              tone === 'error'
                ? 'bg-destructive/10 text-destructive'
                : 'bg-muted text-muted-foreground',
            )}
          >
            {icon}
          </div>
        ) : null}
        <div className="flex max-w-md flex-col gap-2">
          <p className="text-[15.5px] font-bold leading-tight text-foreground">
            {title}
          </p>
          {description ? (
            <p className="text-[13.5px] leading-relaxed text-muted-foreground">
              {description}
            </p>
          ) : null}
        </div>
        {action ? <div>{action}</div> : null}
      </CardContent>
    </Card>
  );
}
